module.exports = __webpack_public_path__ + "assets/sa-website.4d8efbf7.svg";